import React, { createContext, useContext, useEffect } from 'react';
import { useSettingsStore } from '../stores/useSettingsStore.js';

type Theme = 'classic' | 'hive' | 'light';

const ThemeContext = createContext<{
    theme: Theme;
    setTheme: (t: Theme) => void;
}>({ theme: 'classic', setTheme: () => console.log('Theme change requested') });

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    const theme = useSettingsStore(state => state.theme);
    const setTheme = useSettingsStore(state => state.setTheme);

    useEffect(() => {
        const savedTheme = sessionStorage.getItem('beehive-theme') as Theme;
        if (
            savedTheme &&
            (savedTheme === 'classic' || savedTheme === 'hive' || savedTheme === 'light')
        ) {
            setTheme(savedTheme);
            sessionStorage.removeItem('beehive-theme');
        }
    }, [setTheme]);

    const handleSetTheme = (newTheme: Theme) => {
        setTheme(newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, setTheme: handleSetTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useTheme = () => useContext(ThemeContext);
